<div id="member-account-dropdown-container" class="dropdown">
  <button
    class="btn btn-light d-flex align-items-center"
    type="button"
    id="dropdownMenuButton"
    aria-haspopup="true"
    [ngClass]="{ 'dropdown-toggle': (list$ | async)?.length > 1 }"
    (click)="toggleDropdown()"
  >
    <div class="me-2">
      <label
        class="selected-info member align-items-start justify-content-start d-flex"
      >
        <div class="me-1">{{ "Member number" | textTransform }}:</div>
        {{ (loggedIn$ | async)?.memberNumber }}
      </label>
      <label
        class="selected-info account align-items-start justify-content-start d-flex"
      >
        <div>{{ "Account number" | textTransform }}:</div>
        {{ (selected$ | async)?.accountNumber }}
      </label>
    </div>
  </button>
  <ul
    class="dropdown-menu"
    *ngIf="(list$ | async)?.length > 1"
    [ngClass]="{
      'd-block': opened,
      'd-none': !opened
    }"
    appanimatecss="animate__fadeIn"
    appClickOutside 
    (appClickOutside)="closeDropdown()"
  >
    <li
      *ngFor="let item of list$ | async"
      [ngClass]="{
        'selected-account': item.accountId == (selected$ | async)?.accountId,
      }"
    >
      <a class="dropdown-item d-flex p-2" (click)="onSelecteAccountClick(item)">
        <mat-icon class="me-3">chevron_right</mat-icon>
        <div class="d-flex flex-column account-info-container">
          <label class="label-info"
            ><span class="account-info">Account number: </span>
            {{ item.accountNumber }}</label
          >
          <label class="label-info"
            ><span class="account-info">Account type: </span>
            {{ item.accountTypeName }}</label
          >
        </div>
      </a>
    </li>
  </ul>
</div>
